var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 160,
    viewBox: "0 0 300 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5409_18820)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 145.5,
    rx: 140,
    ry: 12.5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.941 62.5073C175.891 62.5129 176.82 62.785 177.624 63.2927C184.766 67.8125 190.653 74.0605 194.74 81.4588C198.828 88.8571 200.983 97.1667 201.008 105.619C201.041 114.806 198.528 123.823 193.747 131.669C188.966 139.514 182.104 145.881 173.923 150.062C173.369 150.347 172.755 150.494 172.133 150.49H129.882C129.259 150.494 128.645 150.347 128.091 150.062C119.909 145.882 113.045 139.516 108.263 131.67C103.481 123.825 100.967 114.807 101 105.619C101.025 97.1661 103.182 88.8561 107.27 81.4578C111.359 74.0594 117.247 67.8117 124.391 63.2927C125.191 62.7836 126.119 62.5114 127.067 62.5073H174.941Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.03 108.503C190.505 108.503 190.002 108.295 189.631 107.923C189.26 107.552 189.051 107.049 189.051 106.524C189.035 101.118 187.939 95.7694 185.828 90.7925C183.716 85.8157 180.632 81.3107 176.756 77.5421C176.406 77.1716 176.212 76.6802 176.215 76.1702C176.218 75.6603 176.418 75.1712 176.773 74.805C177.128 74.4387 177.61 74.2236 178.12 74.2045C178.629 74.1854 179.127 74.3637 179.508 74.7023C183.767 78.8366 187.156 83.7801 189.478 89.2425C191.8 94.7049 193.007 100.576 193.028 106.511C193.03 106.774 192.979 107.034 192.879 107.277C192.78 107.52 192.632 107.74 192.446 107.926C192.26 108.111 192.039 108.258 191.796 108.357C191.553 108.456 191.293 108.506 191.03 108.503Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.809 117.619C191.809 117.619 192.619 116.809 192.619 115.809C192.619 114.81 191.809 114 190.809 114C189.81 114 189 114.81 189 115.809C189 116.809 189.81 117.619 190.809 117.619Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.689 128.802C139.689 128.802 134.751 134.915 133.074 137.076C131.396 139.238 130.805 141.524 132.37 142.869C135.511 145.545 139.538 144.835 147.027 130.743C147.027 130.743 145.142 145.545 151.425 145.545C157.708 145.545 155.823 130.743 155.823 130.743C163.312 144.835 168.539 145.545 170.48 142.869C171.737 141.16 171.448 139.238 169.77 137.076C168.093 134.915 163.161 128.802 163.161 128.802C176.983 140.412 179.063 133.2 179.314 131.102C179.565 129.003 175.28 127.294 170.217 125.29C164.744 123.123 166.296 120.628 166.296 120.628C185.414 98.7648 168.338 83.9817 151.444 83.9817C134.55 83.9817 117.442 98.7648 136.548 120.628C136.548 120.628 139.771 125.422 130.397 123.286C130.397 123.286 125.051 122.413 119.867 117.229C119.867 117.229 115.47 112.706 112.253 117.387C109.426 121.521 118.41 131.73 139.689 128.802Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.865 100.072C162.14 100.073 161.44 100.342 160.9 100.828C160.361 101.313 160.02 101.981 159.942 102.702C159.864 103.424 160.055 104.148 160.479 104.738C160.902 105.327 161.528 105.739 162.237 105.896C162.444 105.935 162.654 105.954 162.865 105.952C163.645 105.952 164.393 105.642 164.944 105.091C165.496 104.539 165.806 103.792 165.806 103.012C165.806 102.232 165.496 101.484 164.944 100.933C164.393 100.381 163.645 100.072 162.865 100.072Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.866 112.398C162.71 112.397 162.554 112.422 162.407 112.474C162.109 112.579 161.857 112.786 161.695 113.057C161.533 113.329 161.47 113.649 161.519 113.961C161.568 114.274 161.724 114.56 161.961 114.769C162.198 114.979 162.501 115.099 162.817 115.109C163.133 115.119 163.443 115.019 163.693 114.825C163.942 114.63 164.117 114.355 164.185 114.046C164.253 113.737 164.212 113.414 164.067 113.133C163.923 112.851 163.684 112.629 163.393 112.505C163.227 112.434 163.047 112.397 162.866 112.398Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.866 105.952V111.871",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.349 100.071C139.614 100.057 138.9 100.319 138.348 100.804C137.797 101.29 137.447 101.965 137.368 102.696C137.289 103.427 137.487 104.16 137.922 104.753C138.358 105.345 138.999 105.753 139.72 105.895C139.927 105.935 140.138 105.954 140.349 105.952C141.128 105.952 141.876 105.642 142.428 105.091C142.979 104.539 143.289 103.791 143.289 103.012C143.289 102.232 142.979 101.484 142.428 100.933C141.876 100.381 141.128 100.071 140.349 100.071Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.349 112.398C140.191 112.397 140.034 112.423 139.884 112.474C139.55 112.588 139.271 112.823 139.102 113.133C138.934 113.442 138.888 113.804 138.973 114.147C139.059 114.489 139.27 114.787 139.564 114.981C139.859 115.175 140.216 115.251 140.564 115.195C140.912 115.138 141.226 114.953 141.444 114.676C141.663 114.398 141.769 114.049 141.742 113.698C141.715 113.346 141.556 113.017 141.299 112.776C141.041 112.536 140.702 112.401 140.349 112.398Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.349 105.952V111.871",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 112.104C150.874 112.104 150.088 113.38 150.088 115.2C150.088 117.02 150.898 118.295 152 118.295C153.102 118.295 153.912 117.02 153.912 115.2C153.912 113.38 153.126 112.104 152 112.104ZM152 109C154.763 109 157 111.771 157 115.2C157 118.629 154.763 121.399 152 121.399C149.237 121.399 147 118.62 147 115.2C147 111.779 149.237 109 152 109Z",
    stroke: "#777A7D",
    strokeWidth: 2.05378,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9981 121.876L71.9914 121.878C72.0832 121.88 72.1744 121.863 72.2596 121.828C72.3448 121.794 72.4224 121.743 72.4878 121.678C72.5533 121.613 72.6053 121.536 72.641 121.451C72.6767 121.366 72.6952 121.274 72.6956 121.182C72.7207 117.652 72.8208 112.435 72.9952 108.915C73.0046 108.823 72.9945 108.729 72.9658 108.641C72.9371 108.552 72.8902 108.471 72.8284 108.401C72.7665 108.332 72.6909 108.276 72.6065 108.238C72.522 108.2 72.4306 108.18 72.3381 108.179C72.1007 108.162 71.5839 108.161 71.3464 108.143C71.2539 108.138 71.1613 108.151 71.0738 108.181C70.9864 108.212 70.9059 108.26 70.8369 108.322C70.768 108.384 70.7119 108.459 70.672 108.543C70.6321 108.627 70.6091 108.719 70.6043 108.812C70.4219 112.366 70.3248 117.603 70.2972 121.161C70.2963 121.254 70.3138 121.346 70.3486 121.433C70.3834 121.52 70.4348 121.598 70.5 121.665C70.5651 121.732 70.6427 121.785 70.7282 121.821C70.8137 121.857 70.9054 121.876 70.9981 121.876Z",
    fill: "#777A7D",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.775 107.967C71.775 107.967 70.6809 56.7519 103.301 22.8309C116.156 8.6609 166 -24.5 215 52.0002",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9139 109.584C89.0086 100.909 73.9231 86.8055 73.9231 86.8055C94.7446 80.5753 78.7316 66.5481 78.7316 66.5481C101.451 62.1041 88.123 43.9229 88.123 43.9229C88.123 43.9229 112.36 44.325 103.681 23.104",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.157 59.9403C218.132 60.3746 220.086 59.1252 220.52 57.1497C220.954 55.1742 219.705 53.2207 217.729 52.7864C215.754 52.3521 213.8 53.6015 213.366 55.577C212.932 57.5525 214.181 59.506 216.157 59.9403Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.606 63.7064C231.12 64.6451 231.245 65.7474 230.956 66.7774C230.666 67.8073 229.985 68.6828 229.057 69.2165C228.13 69.7501 227.031 69.8994 225.995 69.6323C224.959 69.3652 224.069 68.703 223.515 67.7876",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.034 59.6919L223.515 67.7875",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3025 146.186C55.9042 148.911 51.0622 135.261 51.0622 135.261C50.7838 150.727 46.5802 153.645 43.731 152.182C41.9084 151.24 41.2959 149.469 41.7871 146.863C42.2783 144.258 43.8681 136.807 43.8681 136.807C37.0224 152.917 32.0409 147.579 30.9232 145.894C29.8055 144.208 32.7314 140.826 36.2225 136.874C40.0029 132.595 37.5624 131.132 37.5624 131.132C11.4293 120.65 19.6824 100.365 34.28 92.943C48.8776 85.5207 70.1006 90.7631 63.2241 118.079C63.2241 118.079 62.9704 120.915 68.657 120.384C73.9082 119.886 78.3783 119.512 79.0722 121.403C79.7661 123.295 81.1592 130.476 64.0817 126.508C64.0817 126.508 71.0414 129.613 73.4388 130.755C75.8362 131.898 77.3494 133.6 76.5926 135.447C75.0359 139.094 71.2633 140.299 58.5995 131.414C58.6028 131.444 66.7539 143.395 61.3025 146.186Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6245 114.574C51.6008 116.487 53.1176 117.401 54.2993 116.793C55.481 116.186 55.6412 114.419 54.6649 112.506C53.6885 110.593 52.1784 109.671 50.99 110.287C49.8017 110.903 49.6382 112.639 50.6245 114.574ZM57.9125 110.867C59.7506 114.479 58.875 118.603 55.9747 120.098C53.0745 121.592 49.2117 119.862 47.3669 116.259C45.5221 112.656 46.4193 108.522 49.3113 107.021C52.2032 105.52 56.0893 107.254 57.9009 110.831L57.9125 110.867Z",
    stroke: "#777A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7508 97.6782C55.1128 97.4915 55.522 97.416 55.9268 97.4614C56.3316 97.5067 56.714 97.6708 57.0257 97.9331C57.3375 98.1953 57.5646 98.5438 57.6787 98.9349C57.7927 99.326 57.7885 99.742 57.6665 100.131C57.5446 100.519 57.3104 100.863 56.9934 101.119C56.6764 101.375 56.2907 101.531 55.8851 101.568C55.4794 101.605 55.0719 101.522 54.7137 101.328C54.3555 101.134 54.0628 100.838 53.8723 100.478C53.7418 100.237 53.661 99.9729 53.6346 99.7005C53.6082 99.4281 53.6368 99.1532 53.7188 98.892C53.8007 98.6309 53.9343 98.3889 54.1116 98.1804C54.2889 97.9718 54.5062 97.8011 54.7508 97.6782Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2264 105.587C39.5884 105.4 39.9976 105.325 40.4024 105.37C40.8072 105.416 41.1896 105.58 41.5013 105.842C41.813 106.104 42.0402 106.453 42.1543 106.844C42.2683 107.235 42.2641 107.651 42.1421 108.04C42.0202 108.428 41.7859 108.772 41.4689 109.028C41.1519 109.284 40.7663 109.44 40.3607 109.477C39.955 109.514 39.5475 109.431 39.1893 109.237C38.8311 109.043 38.5384 108.747 38.3479 108.387C38.2174 108.146 38.1366 107.882 38.1102 107.609C38.0838 107.337 38.1124 107.062 38.1944 106.801C38.2763 106.54 38.4099 106.298 38.5872 106.089C38.7645 105.881 38.9818 105.71 39.2264 105.587Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.961 148.83C242.485 151.289 246.659 137.421 246.659 137.421C247.688 152.855 252.028 155.565 254.803 153.965C256.578 152.937 257.104 151.138 256.486 148.559C255.869 145.981 253.92 138.616 253.92 138.616C261.539 154.374 266.256 148.801 267.291 147.064C268.325 145.326 265.239 142.09 261.56 138.312C257.576 134.221 259.943 132.641 259.943 132.641C285.537 120.904 276.309 101.043 261.368 94.3381C246.428 87.6329 225.484 93.8989 233.678 120.849C233.678 120.849 234.069 123.67 228.363 123.415C223.094 123.172 218.611 123.016 218.01 124.938C217.409 126.861 216.366 134.101 233.23 129.309C233.23 129.309 226.43 132.748 224.09 134.006C221.751 135.263 220.323 137.037 221.168 138.845C222.9 142.412 226.726 143.433 238.944 133.944C238.942 133.974 231.381 146.306 236.961 148.83Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.498 113.265C246.616 115.224 245.145 116.211 243.935 115.661C242.725 115.111 242.48 113.355 243.362 111.397C244.245 109.438 245.708 108.443 246.925 109.001C248.142 109.559 248.389 111.285 247.498 113.265ZM240.039 109.917C238.378 113.614 239.453 117.69 242.422 119.042C245.392 120.394 249.166 118.479 250.834 114.791C252.501 111.102 251.405 107.017 248.443 105.658C245.482 104.299 241.685 106.22 240.049 109.88L240.039 109.917Z",
    stroke: "#777A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.77 97.04C245.399 96.8711 244.987 96.8156 244.585 96.8805C244.182 96.9455 243.808 97.1279 243.51 97.405C243.211 97.682 243.001 98.0412 242.906 98.4373C242.811 98.8335 242.836 99.2488 242.976 99.6311C243.117 100.013 243.368 100.346 243.697 100.586C244.026 100.826 244.419 100.963 244.825 100.981C245.232 100.998 245.635 100.895 245.984 100.683C246.332 100.472 246.61 100.163 246.783 99.7938C246.902 99.5471 246.97 99.2792 246.983 99.0058C246.996 98.7324 246.954 98.4592 246.859 98.2024C246.765 97.9455 246.62 97.7103 246.433 97.5106C246.245 97.3109 246.02 97.1509 245.77 97.04Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.468 103.278C260.098 103.109 259.685 103.054 259.283 103.119C258.881 103.184 258.507 103.366 258.209 103.643C257.91 103.92 257.7 104.279 257.605 104.675C257.51 105.072 257.534 105.487 257.675 105.869C257.816 106.251 258.066 106.584 258.395 106.824C258.725 107.064 259.117 107.201 259.524 107.219C259.931 107.236 260.334 107.133 260.683 106.921C261.031 106.71 261.309 106.401 261.482 106.032C261.6 105.785 261.668 105.517 261.681 105.244C261.695 104.97 261.653 104.697 261.558 104.44C261.464 104.184 261.318 103.948 261.131 103.749C260.944 103.549 260.719 103.389 260.468 103.278Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1063 86.6213C28.1063 86.6213 28.4367 77.6229 20.7643 74.9158C13.0918 72.2086 9.30861 80.2007 13.3489 83.775C17.2607 87.2328 18.1561 83.489 22.5233 84.0625C25.6192 84.4579 28.1063 86.6213 28.1063 86.6213Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0119 92.8362C14.0119 92.8362 11.1288 87.406 5.67737 88.44C0.225894 89.4739 0.72849 95.4882 4.33262 96.1995C7.82201 96.8995 7.07051 94.3861 9.84417 93.2284C11.1759 92.7385 12.6121 92.6034 14.0119 92.8362Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.443 86.3843C273.443 86.3843 275.58 77.6371 283.699 77.1258C291.819 76.6145 293.279 85.3355 288.417 87.672C283.71 89.9314 283.87 86.0853 279.512 85.4457C276.425 84.9814 273.443 86.3843 273.443 86.3843Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.307 96.2087C285.307 96.2087 289.562 91.771 294.524 94.253C299.487 96.735 297.363 102.384 293.701 102.085C290.153 101.807 291.562 99.5935 289.209 97.723C288.062 96.8884 286.717 96.3666 285.307 96.2087Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5409_18820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 160,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.3a04e12b.svg";
export { ForwardRef as ReactComponent };